import * as queryString from 'x-query-string';

import { ProcessPaymentRequest } from '@cashier/cashier-api-model';
import { IntegrationSources } from '@cashier/cashier-model';

export const convertToProcessRequestBody = ({
  paymentType,
  paymentMethodId,
  userId,
  sessionId,
  vendor,
  merchantId,
  paymentAttributes,
  referenceId,
  callbackParameterBag,
  source,
  accountId,
}: ProcessPaymentRequest): object => {
  const { bonusCode, orderId, ...paymentAttributesWithoutBonusCodeAndOrderId } =
    paymentAttributes;

  const requestData = {
    [IntegrationSources.Internal]: {
      type: paymentType,
      paymentMethodId,
      userId,
      sessionId,
      paymentAttributes: paymentAttributesWithoutBonusCodeAndOrderId,
      merchantId,
      referenceId,
      attributes: {
        bonusCode,
        orderId,
      },
      successRedirectUrl: `${window.location.origin}/success?${queryString.encode(callbackParameterBag)}`,
      failureRedirectUrl: `${window.location.origin}/failure?${queryString.encode(callbackParameterBag)}`,
    },
    [IntegrationSources.External]: {
      type: paymentType,
      walletId: userId,
      sessionId,
      merchantId,
      referenceId,
      returnUrl: `${window.location.origin}/confirm?${queryString.encode(callbackParameterBag)}`,
      payment: {
        accountId,
        methodId: paymentMethodId,
        serviceId: vendor,
        attributes: paymentAttributes,
      },
    },
  };

  return requestData[source];
};
